import React from 'react';
import './Button.css';

/**
 * SupportButton Component
 * Button specifically styled for support actions
 * 
 * @param {function} onClick - Click handler
 * @param {ReactNode} children - Button content
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional CSS classes
 */
const SupportButton = ({ 
  onClick, 
  children, 
  disabled = false, 
  className = '' 
}) => {
  return (
    <button
      className={`support-button ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default SupportButton;

